module.exports = __webpack_public_path__ + "static/media/mreavesxlsannaru-020415006EmigreWebOnly.20bdd1a1.woff";